import { FormikProps, useField } from 'formik';
import { NotePayload } from '../models/requestModels.ts/note';

const TextArea = ({
	labelClassName,
	disabled = false,
	placeholder,
	formik,
	...props
}: {
	placeholder: string;
	labelClassName?: string;
	formik: FormikProps<NotePayload>;
	disabled?: boolean;
}) => {
	return (
		<label className={`flex flex-col ${labelClassName}`}>
			<textarea
				disabled={disabled}
				className="h-[150px] p-2 rounded-md border-2 border-rcrm-primary-border-blue w-full"
				placeholder={placeholder}
				{...formik.getFieldProps('value')}
			></textarea>
			{formik.touched['value'] && formik.errors['value'] ? (
				<div className="text-xs text-rcrm-error">
					{formik.errors['value']}
				</div>
			) : null}
		</label>
	);
};

export default TextArea;
